import React from 'react';
import AppButton from '@mysimpledb/shared/components/UI/Button/Button';

const UserSettings = ({
  settings,
  errors = {},
  loading = false,
  onFieldChange,
  onSave,
}) => {
  return (
    <div className="sharing-container">
      <div className="section">
        <h2>Search Preferences</h2>

        <p style={{ color: '#666', marginBottom: 24 }}>
          Choose which fields are included in the broad search box.
        </p>

        {errors.load ? (
          <div className="error-text">Failed to load settings.</div>
        ) : null}
        {errors.save ? (
          <div className="error-text">Failed to save settings.</div>
        ) : null}

        <ul className="checkbox-list">
          <li>
            <label>
              <input
                type="checkbox"
                checked={!!settings.broad_search_title}
                onChange={(e) =>
                  onFieldChange('broad_search_title', e.target.checked)
                }
              />{' '}
              Include Title
            </label>
          </li>

          <li>
            <label>
              <input
                type="checkbox"
                checked={!!settings.broad_search_keywords}
                onChange={(e) =>
                  onFieldChange('broad_search_keywords', e.target.checked)
                }
              />{' '}
              Include Keywords
            </label>
          </li>

          <li>
            <label>
              <input
                type="checkbox"
                checked={!!settings.broad_search_category}
                onChange={(e) =>
                  onFieldChange('broad_search_category', e.target.checked)
                }
              />{' '}
              Include Category
            </label>
          </li>

          <li>
            <label>
              <input
                type="checkbox"
                checked={!!settings.broad_search_detail}
                onChange={(e) =>
                  onFieldChange('broad_search_detail', e.target.checked)
                }
              />{' '}
              Include Detail Text
            </label>
          </li>
        </ul>
      </div>

      <div className="sharing-save">
        <AppButton
          variant="solid"
          disabled={loading}
          onPress={onSave}
          style={{ width: 150 }}
        >
          {loading ? 'Saving…' : 'Save'}
        </AppButton>
      </div>
    </div>
  );
};

export default UserSettings;
